import styled from "styled-components";

import { BodyText } from "@braze/beacon-core";

export const StyledBodyText = styled(BodyText)`
  strong {
    text-decoration: none;
  }
`;
